import React, { useMemo } from 'react';
import { TableInstance } from 'react-table';

import { InboundDeliveryNote } from '@work4all/models/lib/Classes/InboundDeliveryNote.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { EntityTable, IEntityTable } from './entity-table/EntityTable';
import { useEntityDataTable } from './entity-table/use-entity-data-table';
import { useCloneConvertTableErpActions } from './offers-table/hooks/use-clone-convert-erp';
import schema from './schemata/inboundDeliveryNote-table-schema.json';
import { useErpHandlersTemplate } from './use-erp-handlers-template';

type Props = IEntityTable;

const defaultSort = [
  { field: 'date', direction: SortDirection.DESCENDING },
  { field: 'number', direction: SortDirection.DESCENDING },
];
const FORCE_REQUEST_FIELDS: InboundDeliveryNote<EMode.query> = {
  positionList: [{ id: null, originalId: null }],
};

export const InboundDeliveryNotesTable = React.forwardRef<TableInstance, Props>(
  function InboundDeliveryNotesTable(props, ref) {
    const { ...rest } = props;

    const template = useErpHandlersTemplate();
    const dataTable = useEntityDataTable<InboundDeliveryNote, never>({
      schema: schema as never,
      defaultSort,
      forceRequestFields: FORCE_REQUEST_FIELDS,
      rowModifiers: (value) => {
        return {
          isFaded: value.isClosed && value.frozen,
          isShade1: !value.isClosed && value.frozen,
        };
      },
    });

    const { actions } = useCloneConvertTableErpActions({
      entity: Entities.inboundDeliveryNote,
    });

    const custom = useMemo(
      () => ({
        left: actions,
      }),
      [actions]
    );

    return (
      <EntityTable
        ref={ref}
        template={template}
        {...dataTable}
        actions={{
          custom,
        }}
        {...rest}
      />
    );
  }
);
